<script>
export default {
  props: {
    results: {
      type: Array,
      required: false,
      default: () => ([
        //
      ]),
    },
  },
};
</script>

<template>
  <div>
    <ul
      class="search-results-dropdown"
      :key="results.length"
      style="max-height: 400px; overflow-y: auto"
    >
      <li
        :key="hashid"
        class="search-results-dropdown__item"
        v-for="({ hashid, name, email }) of results"
      >
        <a
          :href="`/lead/${hashid}`"
          class="search-results-dropdown__link"
        >
          <div
            class="search-results-dropdown__body"
          >
            <span
              v-text="name"
              class="search-results-dropdown__name"
            />

            <span
              v-text="email"
              class="search-results-dropdown__email"
            />
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<style lang="scss">
  @import '../../../sass/variables';

  .search-results-dropdown {
    width: 100%;
    padding: 0px;
    z-index: 999999;
    border-radius: 3px;
    position: absolute;
    top: calc(100% + 8px);
    background-color: $white-gray;
    box-shadow: 0 10px 20px rgba(#6746a2, 0.18);

    &__item {
      padding: 0px;
      list-style-type: none;
    }

    &__link {
      padding: 12px;
      display: block;

      &:hover {
        text-decoration: none;
        background-color: $gray-white-2;
      }

    }

    &__body {
      display: flex;
      flex-flow: column nowrap;
    }

    &__name,
    &__email {
      line-height: 25px;
      color: $gray-dark;
      font-family: $font-family-sans-serif;
    }
  }
</style>
